<template>
  <footer class="footer">      
    <ul>
      <li>
        <router-link class="nav-link" to="/reseller">Reseller</router-link>
      </li>
      <li>
        <a class="nav-link" href="/console/distributor/distributor">Be a Distributor</a>
      </li>
      <li>
        <!-- <router-link class="nav-link" to="/compliance/privacy-policy">Privacy policy</router-link> -->
        <a class="nav-link" href="https://ign-website-strapi-cms.westeurope.cloudapp.azure.com/Privacy" target="_blank">Privacy policy</a>
      </li>
      <li>
        <!-- <router-link class="nav-link" to="/compliance/privacy-policy">Privacy policy</router-link> -->
        <a class="nav-link" href="https://ign-website-strapi-cms.westeurope.cloudapp.azure.com/Paia" target="_blank">PAIA manual</a>
      </li>
      <li>
        <router-link class="nav-link" to="/compliance/terms">Terms &amp; Conditions</router-link>
      </li>
      <li>
        <router-link class="nav-link" to="/compliance/fup-policy">Standard Unlimited Talk fair usage policy</router-link>
      </li>
    </ul>
    <cookie-law theme="blood-orange">
        <div slot="message">
          We use cookies to ensure you get the best possible experience. By using this site we assume your consent, view our <a class="nav-link" href="https://ign-website-strapi-cms.westeurope.cloudapp.azure.com/Privacy">Privacy policy</a> for more info. 
        </div>
    </cookie-law>
  </footer>
</template>

<script>
  import CookieLaw from 'vue-cookie-law'
  export default {
    name: 'site-footer',
    components: { CookieLaw }
  }
</script>

<style lang="scss">
  
</style>
